import { ApiService } from "./api.service";
import { DOMAIN } from "./domain-constant";

export default class WriteInvoiceService extends ApiService {
  namespace = "writeoff-invoice";
  icon = "Pen";
  name = "Write Off";
  favicon = "Pen";
  actionTitle = "Save";
  window = 290;
  Width = 700;
  DOMAIN = DOMAIN.INVOICE_WRITE_OFF;
  action = "action";
  showLeftBar = true;
  singular = this.terminology.invoice.singular;
  plural = this.terminology.invoice.plural;
  vowel = this.terminology.invoice.vowel;

  constructor() {
    super("ar-invoice-writeoffs");
  }
}
